import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js';
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import viewAlertDetailsPopup from '../viewAlertDetailsPopup/viewAlertDetailsPopup.vue';

export default
    {
        name: 'AlertSummary',
        components: {
            moment,
            VPagination,
            viewAlertDetailsPopup,
        },
        data() {
            return {
                baseapi: process.env.VUE_APP_Service_URL,
                studyId: store.getters.getStudyIs,
                token: store.getters.getIdToken,
                headers: {},
                alertLoading: false,
                alertList: [],
                sites: [],
                patients: [],
                alertStatus: [],
                templates: [],
                alertTypes: [],
                readMore: [false],
                readTitleMore: [false],
                selectedSite: "",
                selectedSubject: "",
                selectedAlertType: "",
                selectedStatus: "",
                selectedPriority: "",
                selectedSource: "",
                selectedForm: "",
                dateFrom: "",
                dateTo: "",
                showAlertDetailsPopup: false,
                showLoading:true,
                alertType: "",
                alertId: "",
                currentPage: 1,
                totalPage: 1,
                pageindex: 1,
                pagesize: 10,
                exportAlertData: [],
                defaultdate: localStorage.getItem("dateformat"),
                defaultTime: localStorage.getItem("timeformat"),
            };
        },
        async mounted() {
            window.addEventListener("studyIdChanged", async () => {
                this.studyId = store.getters.getStudyIs;
                await this.listSites();
                await this.getdefaultpatients();
                await this.getAlerTypes();
                await this.getAlertStatus();
                await this.getTemplates();
                await this.listAudit();
            })
            this.token = store.getters.getIdToken;
            this.headers = { headers: { Authorization: "Bearer " + this.token } };
            this.listSites();
            this.getdefaultpatients();
            this.getAlerTypes();
            this.getAlertStatus();
            this.getTemplates();
            this.listAudit();
        },
        methods: {
            showTitleMore(index) {
                this.readTitleMore[index] = true;
            },
            showTitleLess(index) {
                this.readTitleMore[index] = false;
            },
            async listAudit() {
                
                try {
                    this.showLoading=true
                    this.alertLoading = true;
                    const response = await axios.get(
                        `${this.baseapi}/forms/alert/subjectalertaudit?StudyId=${this.studyId}&TemplateName=${this.selectedForm}&Priority=${this.selectedPriority}&AlertType=${this.selectedAlertType}&DataSource=${this.selectedSource}&SubjectId=${this.selectedSubject}&SiteId=${this.selectedSite}&Status=${this.selectedStatus}&StartDate=${this.dateFrom}&EndDate=${this.dateTo}&pageindex=${this.pageindex}&pagesize=${this.pagesize}`, this.headers
                    );
                    
                    this.alertList = response.data.entities;
                    this.alertLoading = false;
                    this.totalPage = parseInt(response.data.totalCount / this.pagesize);
                    if (response.data.totalCount % this.pagesize != 0) {
                        this.totalPage = this.totalPage + 1;
                    }
                    this.showLoading=false
                } catch (error) {
                    this.showLoading=false
                }

            },
            async getexportData() {
                try {
                    const response = await axios.get(
                        `${this.baseapi}/forms/alert/subjectalertaudit?StudyId=${this.studyId}&TemplateName=${this.selectedForm}&Priority=${this.selectedPriority}&AlertType=${this.selectedAlertType}&DataSource=${this.selectedSource}&SubjectId=${this.selectedSubject}&SiteId=${this.selectedSite}&Status=${this.selectedStatus}&StartDate=${this.dateFrom}&EndDate=${this.dateTo}`, this.headers
                    );
                    console.log("Alert audit details:", response.data);
                    this.exportAlertData = response.data.entities;
                    const flatData = this.exportAlertData.map(item => ({
                        ...item,
                        emails: item.emails?.join(", ") || "", 
                        tags: item.tags?.join(", ") || "" ,
                        createdAt : this.filterDate(item.createdAt),         

                    }));
                    this.exportAlertData = flatData;

                } catch (error) {
                    console.error("Error fetching  export alert audit details:", error);
                }
            },
            async listSites() {
                try {
                    const response = await axios.get(
                        `${this.baseapi}/management/site/getallsitesbyuser?studyId=${this.studyId}&sortProperty=siteCode&IsDes=false&getAll=false`, this.headers)
                    this.sites = response.data;
                } catch (error) {
                    console.error("Error fetching sites:", error);
                }
            },
            async getpatients(siteID) {
                if (siteID == "All") {
                    this.getdefaultpatients();
                }
                else {
                    this.getsitepatients(siteID)
                }
            },
            async getdefaultpatients() {
                const currentstudy = store.getters.getStudyIs;
                const idtoken = store.getters.getIdToken;
                await axios
                    .get(
                        `${this.baseapi}/management/patient/listpatient?Studyid=${currentstudy}&SortProperty=subjectId`,
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((res) => {
                        this.patients = res.data.results;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            async getsitepatients(siteID) {
                this.patients = []
                const currentstudy = store.getters.getStudyIs;
                const idtoken = store.getters.getIdToken;
                await axios
                    .get(
                        `${this.baseapi}/management/patient/listpatient?SiteId=${siteID}&Studyid=${currentstudy}`,
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            },
                        }
                    )
                    .then((res) => {
                        this.patients = res.data.results;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            async getAlerTypes() {
                try {
                    const responce = await axios.get(
                        `${this.baseapi}/forms/alert/getalertcategorys`, this.headers)
                    this.alertTypes = responce.data.entities.map(item => item.category);
                } catch (error) {
                    console.error("Error fetching alert types:", error);
                }
            },
            async getAlertStatus() {
                try {
                    const responce = await axios.get(
                        `${this.baseapi}/management/statusmaster/getall?StatusType=Alert`, this.headers)
                    this.alertStatus = responce.data.map(item => item.status);
                } catch (error) {
                    console.error("Error fetching alert status:", error);
                }
            },
            async getTemplates() {
                try {
                    const response = await axios.get(
                        `${this.baseapi}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${this.studyId}`, this.headers
                    );
                    this.templates = response.data.results;
                }
                catch (error) {
                    console.error("Error fetching templates:", error);
                }
            },
            async viewAlertDetails(id, type) {
                this.showAlertDetailsPopup = true;
                this.alertType = type;
                this.alertId = id;
            },
            async closeAlertDetailsPopup() {
                this.showAlertDetailsPopup = false;
            },
            loadPage: function (page) {
                this.currentPage = page;
                this.pageindex = page;
                this.listAudit();
            },
            filterDate(data) {
                if (data) {
                    return moment(data).format(this.defaultdate + " " + this.defaultTime)
                }
            },
            async exporttoexcell() {
                await this.getexportData();
                const worksheet = XLSX.utils.json_to_sheet(this.exportAlertData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                XLSX.writeFile(workbook, "Alert Summary Report.xlsx");
            },
            async exportDataPdf() {
                await this.getexportData();
                // 1) Build the data array exactly like exporttoexcell()
                let tableData;
                //   if (this.fromPage === 'studySummary') {
                // dedupe & strip FORMID
                const filtered = this.exportAlertData.map(item => {
                    const copy = { ...item };
                    delete copy.id;
                    delete copy.siteId;
                    delete copy.subjectId;
                    return copy;
                });
                tableData = filtered;
                // tableData = filtered.reduce((acc, cur) => {
                //   const key = `${cur.QUERYID}_${cur.STUDYREF}`;
                //   if (cur.QUERYID !== null && !acc.some(x => `${x.QUERYID}_${x.STUDYREF}` === key)) {
                //     acc.push(cur);
                //   }
                //   return acc;
                // }, []);
                //   } else {
                //     tableData = this.data;
                //   }

                // 2) Convert JSON → XLSX sheet → HTML string
                const ws = XLSX.utils.json_to_sheet(tableData);
                const html = XLSX.utils.sheet_to_html(ws);

                // 3) Feed that HTML string directly to html2pdf
                html2pdf()
                    .set({
                        margin: 10,
                        filename: `Alert Report Data.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
                    })
                    .from(html)
                    .save();
            },
        }
    };